import React, { useEffect, useState } from 'react'
import LikeImage from 'images/like.png';
import LikeEmptyImage from 'images/like-empty.png';
import PublishImage from 'images/publish.png';
import PublishEmptyImage from 'images/publish-empty.png';
import { withErrorBoundary, GoogleStaticMap } from 'shared';
import { SmartButton } from 'ui/smart-buttons';
import { eventHours, eventDate, eventDateTitle } from './EventHelper';
import OccurrenceRow from './OccurrenceRow';
import EventReservationBlock from './EventReservationBlock';
import { MissingImage } from 'customizations';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import ParkImageSlider from '../parks/ParkImageSlider';

const EventModal = (props) => {
  // State
  const [selectedFilter, setSelectedFilter] = useState(null)
  const [selectedPlan, setSelectedPlan] = useState(null)

  // Consts

  // Hooks
  useEffect(() => {
    let { event } = props;
    if (event && event.isEvent) event.track();
  }, [])

  // Custom Methods

  const renderReservationDetails = () => {
    const { event } = props;
    const details = event?.event_reservation_detail_shuttle?.content;

    if (!details) return null;

    return (
      <div
        className="card event-info"
        style={{
          marginTop: '1rem',
          backgroundColor: '#f8f9fa',
          padding: '1rem 1.25rem',
        }}
      >
        <h1
          className="event-information mb-2"
        >
          Reservation Details
        </h1>

        <div
          className="event-information-detail"
          style={{
            fontSize: '0.95rem',
            lineHeight: '1.5',
            color: '#333',
          }}
          dangerouslySetInnerHTML={{ __html: details }}
        />
      </div>
    );
  };

  const renderBody = () => {
    let { event, smartButtons, reloadSmartButtons, base, subroute } = props;
    return (
      <div className="modal-body">
        <button className="close-modal" onClick={props.onClose}>&times;</button>
        <div className="left-pane">
          <div className="card event-title-card">
            <div className="titlebar-actions">
              {event.isEventlike && App.user && App.user.regular && (
                <>
                  <span className="modal-titlebar-action" onClick={() => event.like()}>
                    <img src={event.isLiked ? LikeImage : LikeEmptyImage} alt={event.isLiked ? "Like icon" : "Unlike icon"} />
                    <span className="text event-information-light">{event.view_count}</span>
                  </span>
                  {event.isRegular && (
                    <span className="modal-titlebar-action follower-action" onClick={() => event.publish()}>
                      <img src={event.isPublished ? PublishEmptyImage : PublishImage} alt={event.isPublished ? "Unpublish icon" : "Publish icon"} />
                      <span className="follower-text event-information-light">Push to Followers</span>
                    </span>
                  )}
                </>
              )}
            </div>
            <h3 className="event-name">{event.name}</h3>
            <ParkImageSlider images={event.image_urls} fallbackImage={MissingImage} />
          </div>

          <div className="card event-info">
            <h1 className="section-title event-information mb-0">Event Information</h1>
            <h2 className="section-title event-information">{event.sub_title}</h2>
            <div className="event-description event-information-detail">
              {event.note && <p>{event.note}</p>}
              <div dangerouslySetInnerHTML={{ __html: event.description }}></div>
            </div>
          </div>
        </div>

        <div className="card right-pane right-card">
          <div className="card event-date-map">
            <div className="event-date-section">
              <FontAwesomeIcon icon={faCalendarAlt} className="calendar-icon" />
              <div className="event-entity-date event-information-detail" title={eventDateTitle(event)}>{eventDate(event, 'longest')}</div>
              <div className="event-entity-time event-information-light" title={eventDateTitle(event)}>{eventHours(event)}</div>
            </div>
          </div>
          {((subroute || '').startsWith('reserve') || (renderRightPane() && React.isValidElement(renderRightPane()) &&
            React.Children.toArray(renderRightPane().props.children).some(child =>
              React.isValidElement(child) ? React.Children.toArray(child.props.children).length > 0 : (typeof child === 'string' && child.trim() !== '')
            )
          )) && (
          <div className="card event-buttons">
            <div className="right-pane" style={{ marginLeft: event.isShuttle ? '0rem' : undefined }}>
              {
                (subroute || '').match(/^(reserve|modifyReservation)/) ?
                <EventReservationBlock {...{ event, base, subroute, reloadSmartButtons }}  action={subroute.startsWith('reserve') ? 'reserve' : 'modifyReservation'} selectedPlan={selectedPlan}
                /> : renderRightPane()
              }
            </div>
          </div>
          )}
          {event.showMap && (
            <div className="card event-map">
              <div className="entity-map">
                <GoogleStaticMap defaultZoom={15} defaultCenter={event.coords} address={event.address} />
              </div>
              <div className="left-pane-text-content">
                <div className="entity-address event-information-light">
                  <a href={event.address_map_url} className="text-ligher" target="_blank">{event.address}</a>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  const renderOccurrences = () => {
    let { event, base } = props;
    return (
      <div className="event-occurrence-list">
        <h1 className="visually-hidden">
          Event Occurrence Table
        </h1>
        {event.hasOccurrences ? (
          <table className="event-occurrence-table">
            <tbody>
              {event.occurrenceObjects.map(occurrence => (
                <OccurrenceRow key={occurrence.id} {...{ event, occurrence, base }} />
              ))}
            </tbody>
          </table>
        ) : (
          <div>Will not occur any time soon.</div>
        )}
      </div>
    );
  }

  const renderRightPane = () => {
    let { event } = props

    if (event.category === 'shuttle') {
      return renderShuttleRightPane()
    }

    return (
      <div className='event-base-info'>
        {event.isEnrollmentPending &&
          <div className="alert alert-warning text-center">
            Enrollment request submitted
          </div>
        }
        {event.occurrences && renderOccurrences()}
        {(event.isEventlike || event.isParkReservation) && renderSmartButtons()}
      </div>
    )
  }

  const renderSmartButtons = () => {
    let { event, smartButtons, reloadSmartButtons, base } = props;
    return (
      <ul className="smart-buttons event-smart-buttons" style={{ listStyle: 'none', padding: 0, margin: 0 }}>
        {smartButtons &&
          smartButtons.map(smartButton => (
            <li key={smartButton.key} style={{ display: 'inline-block', marginRight: '0.5rem' }}>
              <SmartButton
                {...{ smartButton, reloadSmartButtons, base }}
                object={event}
                returnPath={application.path}
              />
            </li>
          ))
        }
      </ul>
    );
  }

  const renderShuttleRightPane = () => {
    const { event, base } = props;

    const shuttleData = {
      reservationDetails: event.event_reservation_detail_shuttle?.content || '',
      filters: (event.occurrence_filters || []).map(filter => ({ id: filter.id, label: filter.label })),
      plans: (event.occurrence_plans || []).map(plan => ({
        id: plan.id,
        label: plan.label,
        filterId: plan.occurrence_filter_id,
        occurrences: plan.occurrences || [],
        reserved: plan.is_reserved
      })),
    };

    const visiblePlans = selectedFilter
      ? shuttleData.plans.filter(plan => plan.filterId === selectedFilter)
      : [];

    const buttonStyle = { width: '100%', height: '3.2rem', fontSize: '1rem' };
    const cardStyle = {
      maxWidth: '380px',
      width: '380px',
      margin: '0 auto',
      padding: '1rem',
      boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
      borderRadius: '8px',
      backgroundColor: '#fff',
    };

    const planRowStyle = {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      gap: '1rem',
      padding: '0.5rem',
      backgroundColor: '#f9f9f9',
      borderRadius: '4px',
      flexWrap: 'wrap',
    };

    const leftColumnStyle = { flex: '1 1 180px', display: 'flex', flexDirection: 'column', gap: '0.25rem' };
    const rightColumnStyle = { display: 'flex', flexDirection: 'column', gap: '0.5rem', minWidth: '120px' };

    return (
      <div className="event-base-info shuttle-reservation-ui" style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        {event.category === 'shuttle' && renderReservationDetails()}

        <div style={cardStyle}>
          <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '0.5rem' }}>
            {shuttleData.filters.map(filter => (
              <button
                key={filter.id}
                className="btn btn-outline-primary occurrence-row-btn"
                style={{ minWidth: '100px', maxWidth: 'calc(100% - 0.25rem)', padding: '0.4rem 0.8rem', fontSize: '0.9rem', flex: '1 1 auto' }}
                onClick={() => { setSelectedFilter(filter.id); setSelectedPlan(null); }}
              >
                {filter.label}
              </button>
            ))}
          </div>
        </div>

        {selectedFilter && (
          <div style={cardStyle}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
              {visiblePlans.length > 0 ? (
                visiblePlans.map(plan => (
                  <div key={plan.id} style={planRowStyle}>
                    {/* Left: occurrences */}
                    <div style={leftColumnStyle}>
                      <div style={{ fontWeight: 600, textAlign: 'left' }}>{plan.label}</div>
                      {plan.occurrences.length > 0 ? (
                        plan.occurrences.map(occ => (
                        <div key={occ.id} style={{ fontSize: '0.85rem', opacity: 0.85, display: 'flex', flexDirection: 'column', lineHeight: '1.3', textAlign: 'left' }}>
                          <span style={{ fontSize: '1rem', marginBottom: '0.2rem', color: '#222' }}>{occ.date}</span>
                          <span style={{ fontSize: '0.8rem', color: '#666', fontStyle: 'italic', fontSize: '0.95rem' }}>{occ.time}</span>
                        </div>

                        ))
                      ) : (
                        <div style={{ fontSize: '0.85rem', fontStyle: 'italic', color: '#555', textAlign: 'left' }}>No occurrences</div>
                      )}
                    </div>

                    {/* Right: buttons */}
                    <div style={rightColumnStyle}>
                      {plan.occurrences.length > 0 && plan.reserved ? (
                        <>
                          <button className="btn btn-outline-primary occurrence-row-btn" style={{ padding: '0.4rem' }} onClick={() => application.go(`${base}/${event.uid}::modifyReservation:${plan.id}`)}>Modify</button>
                          <button className="btn btn-outline-primary occurrence-row-btn" style={{ padding: '0.4rem' }} onClick={async () => { await event.cancelReservation(plan.id); application.go(`${base}/${event.uid}`); }}>Cancel</button>
                        </>
                      ) : plan.occurrences.length > 0 ? (
                        <button className="btn btn-outline-primary occurrence-row-btn" style={{ padding: '0.4rem' }} onClick={() => { setSelectedPlan(plan); application.go(`${base}/${event.uid}::reserve`); }}>Reserve</button>
                      ) : null}
                    </div>
                  </div>
                ))
              ) : (
                <div style={{ fontSize: '0.9rem', color: '#555', fontStyle: 'italic', padding: '0.5rem 0', textAlign: 'left' }}>
                  No occurrences exist for this filter.
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    );
  };

  // Render
  return <div className="EventModal custom-modal"> { renderBody() } </div>
}

export default SmartButton.containerComponent('event', withErrorBoundary(EventModal));
